module.exports = __webpack_public_path__ + "static/media/loading.c2d2e216.gif";